import { legacy } from './legacy.js'

const canonicalQueryPrefix = 'levery.'

export function applyDialogQuery(
  target: URLSearchParams,
  source: URLSearchParams,
) {
  for (const prefix of [legacy.dialogQueryPrefix, canonicalQueryPrefix]) {
    for (const [key, value] of source.entries()) {
      if (key.startsWith(prefix)) target.set(key.slice(prefix.length), value)
    }
  }
}
